export default "__VITE_ASSET__X8yKnji4__"